import {SkeletonBox, SkeletonText} from '@primer/react/experimental'
import styles from './ConversationSidebarSkeleton.module.css'

export function ConversationSidebarSkeleton() {
  return (
    <div className={styles.container}>
      {/* Reviewers Section */}
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <SkeletonText size="bodyMedium" className={styles.sectionTitle} />
          <SkeletonBox className={styles.gearIcon} />
        </div>
        <SkeletonText size="bodySmall" className={styles.subheading} />
        <div className={styles.reviewerRow}>
          <SkeletonBox className={styles.avatar} />
          <SkeletonText size="bodyMedium" className={styles.reviewerName} />
          <SkeletonBox className={styles.requestButton} />
        </div>
      </div>

      {/* Assignees Section */}
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <SkeletonText size="bodyMedium" className={styles.sectionTitle} />
          <SkeletonBox className={styles.gearIcon} />
        </div>
        <SkeletonText size="bodyMedium" className={styles.emptyState} />
      </div>

      {/* Labels Section */}
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <SkeletonText size="bodyMedium" className={styles.sectionTitle} />
          <SkeletonBox className={styles.gearIcon} />
        </div>
        <SkeletonText size="bodyMedium" className={styles.emptyState} />
      </div>

      {/* Projects Section */}
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <SkeletonText size="bodyMedium" className={styles.sectionTitle} />
          <SkeletonBox className={styles.gearIcon} />
        </div>
        <SkeletonText size="bodyMedium" className={styles.emptyState} />
      </div>

      {/* Milestone Section */}
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <SkeletonText size="bodyMedium" className={styles.sectionTitle} />
          <SkeletonBox className={styles.gearIcon} />
        </div>
        <SkeletonText size="bodyMedium" className={styles.emptyState} />
      </div>

      {/* Development Section */}
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <SkeletonText size="bodyMedium" className={styles.sectionTitle} />
          <SkeletonBox className={styles.gearIcon} />
        </div>
        <SkeletonText size="bodySmall" className={styles.developmentDescription} />
        <SkeletonText size="bodyMedium" className={styles.emptyState} />
      </div>

      {/* Notifications Section */}
      <div className={styles.section}>
        <div className={styles.notificationsHeader}>
          <SkeletonText size="bodyMedium" className={styles.sectionTitle} />
          <SkeletonText size="bodyMedium" className={styles.customizeLink} />
        </div>
        <SkeletonBox className={styles.unsubscribeButton} />
        <SkeletonText size="bodySmall" className={styles.notificationReason} />
      </div>

      {/* Participants Section */}
      <div className={styles.section}>
        <SkeletonText size="bodyMedium" className={styles.participantHeader} />
        <SkeletonBox className={styles.avatar} />
      </div>

      {/* Lock Conversation Section */}
      <div className={styles.lockSection}>
        <SkeletonBox className={styles.lockIcon} />
        <SkeletonText size="bodyMedium" className={styles.lockText} />
      </div>
    </div>
  )
}
